import { values } from 'lodash'
import { RootState } from '../../../../store'
import { TestingState } from './types'
import {
  TransferType,
  AlpsStatus,
  NsccStatus,
  ProcessingDirection,
} from '../../../../api/types'

export const alpsStatusSelector = (state: RootState | TestingState) =>
  state.transferDetailsReducer?.transferDetails?.status?.state
export const caseCompletionErrorMessageSelector = (
  state: RootState | TestingState
) => state.caseReducer?.caseCompletionErrorMessage
export const caseCompletionResultsSelector = (
  state: RootState | TestingState
) => state.caseReducer?.caseCompletionResults
export const expectedSettlementDateSelector = (
  state: RootState | TestingState
) =>
  state.transferDetailsReducer?.transferDetails?.anonymousStatus
    ?.expectedSettleDate
export const nsccStatusSelector = (state: RootState | TestingState) =>
  state.transferDetailsReducer?.transferDetails?.status?.nsccState
export const processingDirectionSelector = (state: RootState | TestingState) =>
  state.transferDetailsReducer?.transferDetails?.direction
export const publicStatusSelector = (state: RootState | TestingState) =>
  state.transferDetailsReducer?.transferDetails?.anonymousStatus?.publicStatus
export const accountNumberSelector = (state: RootState | TestingState) =>
  state.transfersReducer?.transferResults[0]?.accountNumber
/* Temporary until Alps returns account number in details. */
export const transferDetailsSelector = (state: RootState | TestingState) =>
  state.transferDetailsReducer.transferDetails
export const transferTypeSelector = (state: RootState | TestingState) =>
  state.transferDetailsReducer?.transferDetails?.transferType
export const canBeCompletedSelector = (state: RootState | TestingState) => {
  const nsccStatus = nsccStatusSelector(state)
  const processingDirection = processingDirectionSelector(state)
  const transferType = transferTypeSelector(state)
  const alpsStatus = alpsStatusSelector(state)

  const isValidNsccStatus = [
    NsccStatus.ReviewError,
    NsccStatus.ReviewAdjustDeliverer,
    NsccStatus.Review,
  ].some(status => status === nsccStatus)
  const isValidProcessingDirection =
    processingDirection === ProcessingDirection.Joining
  const validTransferTypes = values(TransferType).filter(
    type => type !== TransferType.Reclaim
  )
  const isValidTransferType = validTransferTypes.some(
    type => type === transferType
  )
  const isValidAlpsStatus = alpsStatus === AlpsStatus.ReviewAlpsApproval

  return (
    isValidNsccStatus &&
    isValidProcessingDirection &&
    isValidTransferType &&
    isValidAlpsStatus
  )
}
